import React, { useState } from "react";

import classes from "./AddTask.module.css";

import Container from "../UI/Container";

import Inner from "../UI/Inner";

const AddTask = (props) => {
  const [enteredTask, setEnteredTask] = useState("");

  const addTaskHandler = (event) => {
    event.preventDefault();
    if (enteredTask.trim().length === 0) {
      return;
    }

    props.onAddTask(enteredTask);
    setEnteredTask("");
  };

  const taskChangeHandler = (event) => {
    setEnteredTask(event.target.value);
  };

  return (
    <Container>
      <p className={classes.headline}>
        TODO<span className={classes["headline-2"]}>List</span>
      </p>

      <Inner>
        <form onSubmit={addTaskHandler}>
          <input
            className={classes.input}
            type="text"
            placeholder="What will you do today?"
            onChange={taskChangeHandler}
            value={enteredTask}
          />

          <button type="submit" className={classes.button}>
            ADD
          </button>
        </form>
      </Inner>
    </Container>
  );
};

export default AddTask;
